export default __webpack_public_path__ + "static/media/SeloGPTW2025.deeb7089.png";